import { useManageMyGivingPage } from "../ManageMyGivingPageContext";

export default function usePaymentMethodTypes() {
  const { state } = useManageMyGivingPage();
  const { paymentMethodTypes } = state;

  function getPaymentMethodTypeById(id) {
    const types = structuredClone(paymentMethodTypes);

    // replace checking and savings with lowercase strings and removing 'account'
    Object.entries(types).forEach(([key, value]) => {
      let isChecking = /(checking)/gi.test(value);
      let isSavings = /(savings)/gi.test(value);

      if (isChecking) {
        types[key] = "checking";
      } else if (isSavings) {
        types[key] = "savings";
      }
    });

    return types[id];
  }

  return { getPaymentMethodTypeById };
}
